export default {"src":"/_next/static/media/pricetag-alternate.ad4bc4f7.svg","height":39,"width":39,"blurWidth":0,"blurHeight":0};